module.exports = __webpack_public_path__ + "static/scale-model-of-stingray-beach-in-omaha-nebraska-16c9de3db47c531a28518007d405a2e8.png";